import React, { useState } from "react";
import { useFormikContext, useField } from "formik";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import i18n from "i18n";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
import ServiceAccountKeyFilePicker from "./ServiceAccountKeyFilePicker";
import { GCS_AUTH_MODE } from "./types";
const AUTH_OPTIONS = [
  { value: GCS_AUTH_MODE.AUTOMATIC, labelKey: "gcs_credentials.auth_automatic" },
  { value: GCS_AUTH_MODE.SERVICE_ACCOUNT_KEY, labelKey: "gcs_credentials.auth_service_account_key" }
];
export const validateGcsCredentialsFields = (credentials) => {
  const errors = {};
  if (!credentials) return errors;
  if (credentials.auth_mode === GCS_AUTH_MODE.SERVICE_ACCOUNT_KEY && !credentials.service_account_key) {
    errors.service_account_key = i18n.t("gcs_credentials.service_account_key_required", {
      ns: "enterprise_data_tiering"
    });
  }
  return errors;
};
const GcsCredentialsFieldGroup = () => {
  var _a, _b;
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const productName = useProductName();
  const { t } = useTranslation("enterprise_data_tiering");
  const authOptions = AUTH_OPTIONS.map(({ value, labelKey }) => ({ value, label: t(labelKey) }));
  const [fileName, setFileName] = useState();
  const [, { error: authModeError, touched: authModeTouched }] = useField("credentials.auth_mode");
  const [, { error: keyError, touched: keyTouched }] = useField("credentials.service_account_key");
  const authMode = (_b = (_a = values.credentials) == null ? void 0 : _a.auth_mode) != null ? _b : GCS_AUTH_MODE.AUTOMATIC;
  const handleAuthModeChange = (nextMode) => {
    if (nextMode === GCS_AUTH_MODE.AUTOMATIC) {
      setFieldValue("credentials.service_account_key", void 0);
      setFileName(void 0);
    }
    setFieldValue("credentials.auth_mode", nextMode);
  };
  const handleFileRead = (content, name) => {
    setFieldTouched("credentials.service_account_key", true, false);
    setFieldValue("credentials.service_account_key", { set_value: content });
    setFileName(name);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "repository-credentials-auth-mode",
      label: t("gcs_credentials.auth_type"),
      bsStyle: authModeError && authModeTouched ? "error" : void 0,
      error: authModeTouched ? authModeError : void 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: t("gcs_credentials.auth_mode_help", { productName })
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        inputId: "repository-credentials-auth-mode-select",
        placeholder: t("gcs_credentials.auth_type_placeholder"),
        options: authOptions,
        onChange: handleAuthModeChange,
        clearable: false,
        value: authMode
      }
    )
  ), authMode === GCS_AUTH_MODE.SERVICE_ACCOUNT_KEY && /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "repository-credentials-service-account-key",
      label: t("gcs_credentials.service_account_key"),
      error: keyTouched ? keyError : void 0,
      bsStyle: keyError && keyTouched ? "error" : void 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: t("gcs_credentials.service_account_key_help")
    },
    /* @__PURE__ */ React.createElement(ServiceAccountKeyFilePicker, { fileName, onFileRead: handleFileRead })
  ));
};
export default GcsCredentialsFieldGroup;
